export function exportCsv(filename: string, headers: string[], rows: string[][]) {
  const content = [
    headers.join(","),
    ...rows.map((row) =>
      row.map((value) => `"${String(value).replaceAll('"', '""')}"`).join(","),
    ),
  ].join("\n");

  const blob = new Blob([content], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  link.click();
  URL.revokeObjectURL(url);
}
